import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Button, Typography } from "@mui/material";

const CustomerDetailErrorView = ({ message, onRetry }) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", py: 4, gap: 2 }}>
      <Typography color="text.secondary">
        {message || t("dsokCustomerDetail.data.loadError")}
      </Typography>
      {onRetry && (
        <Button variant="contained" onClick={onRetry}>
          {t("dsokCustomerDetail.data.retry")}
        </Button>
      )}
    </Box>
  );
};

export default CustomerDetailErrorView;
